// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"ceae8b4e","25":"7ababe0d"}[chunkId] + ".chunk.css";
};